import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { createMultiCartComment } from 'api/cart/createMultiCartComment'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { COMMENT_QUERY_KEY } from 'constants/comments'

interface CreateCommentParams {
  multiCartId: string
  itemId: string
  text: string
}

export function useCreateMultiCartComment() {
  const queryClient = useQueryClient()
  const intl = useIntl()

  return useMutation({
    mutationFn: (params: CreateCommentParams) => createMultiCartComment(
      params.multiCartId,
      params.itemId,
      params.text,
    ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [COMMENT_QUERY_KEY, variables.multiCartId] })
    },
    onError: (error: Error) => {
      showSnackbar(intl.formatMessage({
        id: 'ijNfM9-IXgNIIq6gwcZh',
        defaultMessage: 'Failed to add comment: {errorMessage}',
        description: 'Snackbar error message when creating a shared cart comment fails',
      }, { errorMessage: error.message }), 'critical')
    },
  })
}
